//module.exports = require("./logo/【ロゴ】沖縄電力.JPG");
module.exports = require("./logo/【ロゴ】沖電企業.jpg");
//module.exports = require("./logo/logo.png");
//module.exports = require("./logo/logo.png");